import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import XOutlinedSvg from "@ant-design/icons-svg/es/asn/XOutlined";
import AntdIcon from "../components/AntdIcon";
var XOutlined = function XOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: XOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  XOutlined.displayName = 'XOutlined';
}
export default /*#__PURE__*/React.forwardRef(XOutlined);